<div class="p-20">

  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <h2 style="text-align:center;">{{'CERTIFICAR.ADICIONALES.PREVIEW.TITULO' | translate}}</h2>
    <div fxLayout="column" fxLayoutAlign="stretch">
      <mat-form-field appearance="outline">
        <mat-label>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.ELIGELANG' | translate}}</mat-label>
        <mat-select>
          <mat-option *ngFor="let idioma of idiomasFiltrados" [value]="idioma._id" (click)="selIdiomaPreview(idioma)">
            {{'NOMBREIDIOMAS.'+idioma.clave | translate}}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix class="secondary-text">language</mat-icon>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>

    <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="totalTextosTraduccion == 0 && primeraSeleccion">
        <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
        <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
    </div>

    <div *ngFor="let adicional of textosPreguntasFiltrados;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">
      <mat-list>
        <h2>{{adicional.textoPregunta}}</h2>
        <h4 *ngIf="adicional.tipoPregunta == idSingle"><b>{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.SINGLE' | translate}}</b></h4>
        <h4 *ngIf="adicional.tipoPregunta == idMulti"><b>{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.MULTI' | translate}}</b></h4>

        <ng-container *ngIf="adicional.tipoPregunta == idAbierta">
          <div fxLayout="column" fxLayoutAlign="stretch">
            <mat-form-field appearance="outline">
              <mat-label>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.RESPABIERTA' | translate}}</mat-label>
              <textarea matInput required disabled></textarea>
              <mat-error>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.ERRORABIERTA' | translate}}</mat-error>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="adicional.tipoPregunta != idAbierta">
          <mat-list-item *ngFor="let opcion of adicional.opcionesResp; last as last">

            <ng-container *ngIf="adicional.tipoPregunta == idSingle">
              <mat-radio-button value="1"disabled>
                <h4 mat-line>{{opcion.textoOpcion}}</h4>
              </mat-radio-button>
            </ng-container>
            <ng-container *ngIf="adicional.tipoPregunta == idMulti">
              <mat-checkbox value="1" disabled>
                <h4 mat-line>{{opcion.textoOpcion}}</h4>
              </mat-checkbox>
            </ng-container>

            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </mat-list-item>
        </ng-container>

      </mat-list>
    </div>
  </ng-container>

</div>
